import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from './helper/admin.guard';
import { StaffGuard } from './helper/staff.guard';
import { LogeGuard } from './helper/loge.guard';
import { MaintenanceGuard } from './helper/maintenance.guard';
import { IntendanceGuard } from './helper/intendance.guard';
import { CantineGuard } from './helper/cantine.guard';

const routes: Routes = [
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule) },
  { path: 'admin', loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule), canActivate: [AdminGuard] },
  { path: 'staff', loadChildren: () => import('./modules/staff/staff.module').then(m => m.StaffModule), canActivate: [StaffGuard] },
  { path: 'loge', loadChildren: () => import('./modules/loge/loge.module').then(m => m.LogeModule), canActivate: [LogeGuard] },
  { path: 'cantine', loadChildren: () => import('./modules/cantine/cantine.module').then(m => m.CantineModule), canActivate: [CantineGuard] },
  { path: 'intendance', loadChildren: () => import('./modules/intendance/intendance.module').then(m => m.IntendanceModule), canActivate: [IntendanceGuard] },
  { path: 'maintenance', loadChildren: () => import('./modules/maintenance/maintenance.module').then(m => m.MaintenanceModule), canActivate: [MaintenanceGuard] },
    // Redirection par défaut
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  // 404
  { path: '**', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
